import { Text } from '@chakra-ui/react';
import React from 'react';

import { Alert } from '~/packages/common-frontend/components/Alert';

export const CustomerNotFoundAlert = () => (
  <Alert status="error">
    <Text>Customer not found</Text>
  </Alert>
);
